<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-12">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">CNA na Escola</a></li>
                            <li>Instituições de Ensino</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Instituições de Ensino</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">

                            <div class="row">
                                <div class="form-group col-md-3">
                                    <label for="nomeEscola">Nome da Instituição</label>
                                    <input type="text" class="form-control" name="nomeEscola" placeholder="Nome da instituição de Ensino" v-model="filter.nomeEscola" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="apelido">Razão Social</label>
                                    <input type="text" class="form-control" name="apelido" placeholder="Razão Social da instituição de Ensino" v-model="filter.apelido" />
                                </div>
                                <div class="form-group col-md-2">
                                    <label for="codigoMicrosiga">Microsiga</label>
                                    <input type="text" class="form-control" name="codigoMicrosiga" placeholder="Microsiga Instituição" v-model="filter.codigoMicrosiga" />
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="tipoInstituicaoParceriasIds">Tipo de Parceria CNA na Escola</label>
                                    <select data-placeholder="Selecione.." multiple class="chosen-select" v-select="{ dataitem: 'TipoInstituicaoParceria', default: 'Selecione' }" v-model="filter.tipoInstituicaoParceriasIds" name="tipoInstituicaoParceriasIds"></select>
                                    <figcaption class="figure-caption">Se o campo for deixado em branco, o sistema considerará todas as opção existentes</figcaption>
                                </div>
                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label for="CNPJ">CNPJ</label>
                                    <input type="text" maxlength="18" v-mask="mask_cnpj" class="form-control" name="CNPJ" placeholder="CNPJ da Instituição Ensino" v-model="filter.cPF_CNPJ" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="escolasIds">Franquia CNA</label>
                                    <select multiple v-select="{ dataitem: 'Escola', default: 'Selecione', filters: { attributeBehavior: 'EscolaBox' }}" v-model="filter.escolasIds" class="form-control" name="escolasIds"></select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="tipoContratoInstituicaoEnsinoId">Tipo de Contrato Instituição Ensino</label>
                                    <select multiple v-select="{ dataitem: 'TipoContratoInstituicaoEnsino', default: 'Selecione' }" v-model="filter.tipoContratoInstituicaoEnsinoIds" class="form-control" name="tipoContratoInstituicaoEnsinoIds"></select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="modalidadesIds">Modalidades Liberadas</label>
                                    <select multiple v-select="{ dataitem: 'Modalidade', default: 'Selecione' }" v-model="filter.modalidadesIds" class="form-control" name="modalidadesIds"></select>
                                    <figcaption class="figure-caption">Se o campo for deixado em branco, o sistema considerará todas as opção existentes</figcaption>
                                </div>

                                <div class="form-group col-md-3">
                                    <label for="dataInicioParceria">Data de Início Parceria (De)</label>
                                    <input type="text" v-mask = "'##/##/####'" maxlength="10" v-datepicker class="form-control" name="dataInicioParceria" v-model="filter.dataInicioParceria" />
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="dataTerminoParceria">Data Término Parceria (Até)</label>
                                    <input type="text" v-mask = "'##/##/####'" maxlength="10" v-datepicker class="form-control" name="dataTerminoParceria" v-model="filter.dataTerminoParceria" />
                                </div>

                            </div>
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="situacaoInstituicaoEnsinosIds">Situação da Parceira</label>
                                    <select multiple v-select="{ dataitem: 'SituacaoInstituicaoEnsino', default: 'Selecione' }" v-model="filter.situacaoInstituicaoEnsinosIds" class="form-control" name="situacaoInstituicaoEnsinosIds"></select>
                                    <figcaption class="figure-caption">Se o campo for deixado em branco, o sistema considerará todas as opção existentes</figcaption>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Permite Compra Automática? <i class="fa fa-info-circle" placement="top" v-b-tooltip title="Marque 'SIM' para visualizar as instituições de ensino para as quais foi configurada compra automática do material didático, caso não tenham sido comprados até a data limite de compra.Esta funcionalidade só está disponível para o tipo de contrato 'Instituição Compra Material'"></i></label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio" style="float: left;margin-right:2px;">
                                            <input type="radio" name="permiteCompraAutomatica" v-model="filter.permiteCompraAutomatica" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description"> Todos  </span>
                                        </label>
                                        <label class="custom-control custom-radio" style="float: left;margin-right:2px;">
                                            <input type="radio" name="permiteCompraAutomatica" v-model="filter.permiteCompraAutomatica" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description"> Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio" style="float: left;margin-right:2px;">
                                            <input type="radio" name="permiteCompraAutomatica" v-model="filter.permiteCompraAutomatica" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description"> Não</span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="container-exemplo">
                        <div class="text-right">
                            <div class="example-content-secondary"><b>Total de registros:</b> {{ result.total }}</div>
                        </div>
                    </div>
                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>ESCOLA CNA<i @click="executeOrderBy('Empresa.PessoaEscola.Escola.NomeEscola')" class="fa fa-sort"></i></th>
                                    <th>INSTITUIÇÃO DE ENSINO<i @click="executeOrderBy('Empresa.PessoaEscola.Nome')" class="fa fa-sort"></i></th>
                                    <th>MICROSIGA<i @click="executeOrderBy('InstituicaoEnsino.CodigoMicrosiga')" class="fa fa-sort"></i></th>
                                    <th>TIPO PARCERIA<i @click="executeOrderBy('TipoInstituicaoParceriaId')" class="fa fa-sort"></i></th>
                                    <th>Tipo Contrato Instituição de Ensino<i @click="executeOrderBy('TipoContratoInstituicaoEnsino.Nome')" class="fa fa-sort"></i></th>

                                    <th>MODALIDADES LIBERADAS</th>
                                    <th>Data INÍCIO Parceria<i @click="executeOrderBy('DataInicioParceria')" class="fa fa-sort"></i></th>
                                    <th>Permite Compra Automática<i @click="executeOrderBy('PermiteCompraAutomatica')" class="fa fa-sort"></i></th>
                                    <th>Venda pelo Commerce?<i @click="executeOrderBy('VendaCommerce')" class="fa fa-sort"></i></th>

                                    <th>SITUAÇÃO PARCEIRIA<i @click="executeOrderBy('SituacaoInstituicaoEnsinoId')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.empresa.pessoaEscola.escola.nomeEscola }}</td>
                                    <td>{{ item.empresa.pessoaEscola.nome }}</td>
                                    <td>{{ item.codigoMicrosiga ? item.codigoMicrosiga : '' }}</td>
                                    <td>{{ item.tipoInstituicaoParceria ? item.tipoInstituicaoParceria.nome : ''}}</td>
                                    <td>{{ item.tipoContratoInstituicaoEnsino ? item.tipoContratoInstituicaoEnsino.nome : ''}}</td>

                                    <td>
                                        <ul v-for="item2 in item.collectionInstituicaoEnsinoModalidade" v-bind:key="item2.modalidadeId" >
                                            <li><span :class="retornaBadge(item2.modalidade.nome)">{{ item2.modalidade? item2.modalidade.nome : ''}}</span></li>
                                        </ul>
                                    </td>

                                    <td>{{ item.dataInicioParceria }}</td>

                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.permiteCompraAutomatica, 'badge-danger': !item.permiteCompraAutomatica }">{{item.permiteCompraAutomatica ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.vendaCommerce, 'badge-danger': !item.vendaCommerce }">{{item.vendaCommerce ? 'Sim' : 'Não'}}</span></td>
                                    <td>{{ item.situacaoInstituicaoEnsino.nome}}</td>


                                    <td class="text-center">
                                        <button type="button" v-if="item.vendaCommerce" class="btn btn-sm btn-success" @click="enviarParaCommerce( item.instituicaoEnsinoId )" v-b-tooltip.hover title="Enviar para o Commerce">
                                            <i class="fa fa-send"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" @click="openEdit( item.instituicaoEnsinoId )">
                                            <i class="fa fa-pencil"></i>
                                        </button>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import Global from '@/common/global'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import cadastroPoliticaComercial from '../instituicaoensinopoliticacomercial/form-edit'

    export default {
        name: 'instituicaoensino',
        mixins: [base],
        components: { formCreate, formEdit, cadastroPoliticaComercial },
        data() {
            return {

                resources: {
                    filter: 'instituicaoensino',
                    remove: 'instituicaoensino'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    nomeEscola: "",
                    cPF_CNPJ: "",
                    apelido: "",
                    codigoMicrosiga: "",
                    tipoContratoInstituicaoEnsinosId:"",
                    dataInicioParceria: "",
                    dataTerminoParceria: "",
                    tipoInstituicaoParceriaId: "",
                    tipoContratoInstituicaoEnsinoId:"",
                    permiteCompraAutomatica: null,
                    odalidadesIds: [],
                    situacaoInstituicaoEnsinosIds: [],
                    tipoContratoInstituicaoEnsinoIds:[],
                    escolasIds: [],
                    modalidadesIds: [],
                    tipoInstituicaoParceriasIds:[],
                    escolaIds: "",
                    tipoInstituicaoParceriaIds: [],
                    modalidadeIds: "",
                    situacaoInstituicaoEnsinoIds: "",
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            retornaBadge: function (modalidade) {
                switch (modalidade) {
                    case 'Extensivo':
                        return 'badge badge-secondary';
                    case 'Intensivo':
                        return 'badge badge-primary';
                    case 'Plus':
                        return 'badge badge-danger';
                    case 'Expand':
                    case 'Escola Pública':
                        return 'badge badge-warning';
                    case 'Bilíngue':
                        return 'badge badge-success';
                    case 'Curricular':
                        return 'badge badge-info';
                    case 'Extracurricular':
                        return 'badge badge-light';
                    case 'Integral':
                        return 'badge badge-secondary';
                    default:
                        return 'badge badge-dark';
                }
            },
            openEdit: function (id) {
                //this.instituicaoEnsinoId = model.instituicaoEnsinoId;
                //this.dialogEdit = true;
                this.$router.push({ path: '/instituicaoensino/edit/' + id });
            },
            enviarParaCommerce: function (id) {
                const axios = require('axios');
                const url = Global.END_POINT_COMMERCE + '/franqueador/processar-instituicao';

                axios.post(url, {
                    instituicaoId: id
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => {
                    if (response.status === 200) {
                        this.defaultSuccessResult('Instituição enviada para o Commerce');
                    } else {
                        this.defaultErrorResult('Erro ao enviar a instituição');
                    }
                })
                .catch(error => {
                    const errorMessage = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : error.message;

                    this.defaultErrorResult('Erro ao enviar instituição para o Commerce: ' + errorMessage);
                });
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                console.log(this.filter.tipoInstituicaoParceriasIds.toString());
                if (filter) this.filter = filter;
                this.filter.escolaIds = this.filter.escolasIds.length > 0 ? this.filter.escolasIds.toString() : "";
                this.filter.tipoContratoInstituicaoEnsinoIds = this.filter.tipoContratoInstituicaoEnsinoIds.length > 0 ? this.filter.tipoContratoInstituicaoEnsinoIds.toString() : "";
                this.filter.tipoInstituicaoParceriaIds = this.filter.tipoInstituicaoParceriasIds.length > 0 ?  this.filter.tipoInstituicaoParceriasIds.toString() : "";
                this.filter.modalidadeIds = this.filter.modalidadesIds.length > 0 ? this.filter.modalidadesIds.toString() : "";
                this.filter.situacaoInstituicaoEnsinoIds = this.filter.situacaoInstituicaoEnsinosIds.length > 0 ? this.filter.situacaoInstituicaoEnsinosIds.toString() : "";

                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>